import { NgClass } from '@angular/common';
import { Component, input } from '@angular/core';
import { BadgeStyle } from '@shared/types';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'dxc-badge',
  imports: [NgClass, TooltipModule],
  template: `
    <span
      class="dx-badge select-none inline-flex justify-center min-w-6 items-center rounded-lg px-3 py-1 text-xs font-semibold {{
        additionalClasses()
      }}"
      [ngClass]="styleClasses"
      [pTooltip]="tooltip()"
    >
      <span class="badge-text">{{ text() }}</span>
    </span>
  `
})
export class BadgeComponent {
  public text = input.required<string | number>();
  public tooltip = input.required<string>();
  public style = input.required<BadgeStyle>();
  public additionalClasses = input('');

  get styleClasses() {
    switch (this.style()) {
      case 'green':
        return 'bg-green-100 text-green-800 dark:bg-green-800/30 dark:text-green-400';

      case 'green-outline':
        return 'bg-background border border-border text-green-700 dark:text-green-500';

      case 'blue':
        return 'bg-blue-100 text-blue-800 dark:bg-blue-800/30 dark:text-blue-300';

      case 'blue-outline':
        return 'bg-background border border-border text-blue-700 dark:text-blue-300';

      case 'red':
        return 'bg-red-100 text-red-800 dark:bg-red-800/30 dark:text-red-300';

      case 'red-outline':
        return 'bg-background border border-border text-red-800 dark:text-red-300';

      case 'yellow':
        return 'bg-yellow-100 text-yellow-800 dark:bg-yellow-800/30 dark:text-yellow-500';

      case 'yellow-outline':
        return 'bg-background border border-border text-yellow-700 dark:text-yellow-400';

      case 'orange':
        return 'bg-orange-100 text-orange-800 dark:bg-orange-800/30 dark:text-orange-400';

      case 'orange-outline':
        return 'bg-background border border-border text-orange-700 dark:text-orange-400';

      case 'white':
        return 'bg-background text-text-muted border border-border';

      case 'default':
      default:
        return 'bg-gray-100 text-gray-800 dark:bg-white/10 dark:text-white';
    }
  }
}
